import classNames from "classnames";
import { ExperienceCommonProps } from "PFComponents/experience_level/experience_level.types";
import { useGetColor } from "PFCore/hooks/use_get_color";
import { CustomValue, Experience } from "PFTypes";
import { Fragment, useEffect, useState } from "react";

import { getCircleCenter, getLinePosition, getViewBox } from "../../constants";
import { Line } from "../line";
import { Point } from "../point";
import css from "./rating_dots.module.scss";

export type RatingDotsProps = {
  customValue?: CustomValue;
  experience?: Experience | null;
  size?: number;
  viewBox?: string;
  className?: string;
  color?: string;
  colorSecondary?: string;
  shape?: "circle" | "rect";
} & Pick<ExperienceCommonProps, "experienceLevels">;

export const RatingDots = ({
  experience = null,
  size,
  className,
  color,
  colorSecondary,
  shape = "circle",
  experienceLevels,
  viewBox = getViewBox(experienceLevels.length)
}: RatingDotsProps) => {
  const getColor = useGetColor();
  const [experienceToShow, setExperienceToShow] = useState<Experience>(experience || Experience.None);
  useEffect(() => {
    setExperienceToShow(experience || 0);
  }, [experience]);

  const isCircle = shape === "circle";

  const colorOrDefault = color ?? getColor("paletteBlue0");
  const colorSecondaryOrDefault = colorSecondary ?? getColor("paletteNeutral0");

  return (
    <svg
      className={classNames(css.ratingDots, className)}
      data-level={experience}
      height={size ?? "1em"}
      focusable="false"
      role="presentation"
      viewBox={viewBox}
    >
      {experienceLevels.map((experienceLevel, index) => {
        const isMainColor = experienceToShow >= experienceLevel;

        return (
          <Fragment key={experienceLevel}>
            {isCircle && index > 0 && (
              <Line
                experience={experienceLevel}
                {...getLinePosition(index)}
                color={isMainColor ? colorOrDefault : colorSecondaryOrDefault}
              />
            )}
            <Point
              shape={shape}
              {...getCircleCenter(index)}
              experience={experienceLevel}
              color={isMainColor ? colorOrDefault : colorSecondaryOrDefault}
            />
          </Fragment>
        );
      })}
    </svg>
  );
};
